import type { PropsWithChildren } from 'react';

import {
  CardHeaderStyled,
  type ICardHeaderStyledProps,
} from './styles/CardHeaderStyled'

export interface ICardHeaderProps extends ICardHeaderStyledProps {}

export const CardHeader = ({
  children,
  ...props
}: PropsWithChildren<ICardHeaderProps>) => (
  <CardHeaderStyled {...props}>{children}</CardHeaderStyled>
)

CardHeader.displayName = 'CardHeader'
